<template>
    <v-container class="funcoes-page py-6">
        <v-card class="page-header mb-7" flat dark>
            <v-card-text class="pa-6 pa-md-8">
                <div class="d-flex align-center">
                    <v-avatar color="white" size="56" class="mr-4">
                        <v-icon color="indigo darken-1" size="30">mdi-content-cut</v-icon>
                    </v-avatar>
                    <div>
                        <div class="overline font-weight-bold white--text">Catálogo administrativo</div>
                        <h1 class="display-2 font-weight-bold mb-1">Serviços</h1>
                        <p class="subtitle-1 mb-0 white--text text--lighten-4">
                            Gerencie os serviços disponíveis para agendamento.
                        </p>
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <v-tabs
            v-model="abaSelecionada"
            background-color="transparent"
            color="indigo darken-2"
            class="mb-6"
        >
            <v-tab>Serviços</v-tab>
            <v-tab>Ordem de exibição</v-tab>
        </v-tabs>

        <v-tabs-items v-model="abaSelecionada">
            <v-tab-item>
        <div class="d-flex flex-wrap align-center justify-space-between mb-4">
            <div>
                <h2 class="headline indigo--text text--darken-2 mb-1">Seus serviços</h2>
                <p class="body-2 grey--text text--darken-1 mb-0">
                    {{ items.length }} {{ items.length === 1 ? 'serviço cadastrado' : 'serviços cadastrados' }}
                </p>
            </div>
            <div class="d-flex flex-wrap align-center justify-end mt-3 mt-md-0">
                <v-text-field
                    v-model="busca"
                    label="Buscar serviço"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    dense
                    outlined
                    hide-details
                    class="service-search mr-3"
                ></v-text-field>
                <NovaFuncaoDialog :acaoEditar="false" @recarregarLista="carregar" />
            </div>
        </div>

        <v-divider class="mb-6"></v-divider>

        <v-card v-if="items.length" class="services-list-card" outlined>
            <v-data-table
                :headers="headers"
                :items="items"
                :search="busca"
                :items-per-page="25"
                sort-by="ordem"
                class="services-table"
                no-data-text="Nenhum serviço encontrado"
                no-results-text="Nenhum serviço encontrado"
            >
                <template v-slot:item.descricao="{ item }">
                    <div class="font-weight-bold indigo--text text--darken-3">
                        {{ item.descricao }}
                    </div>
                    <div class="caption grey--text text--darken-1">
                        Ordem {{ item.ordem }}
                    </div>
                </template>

                <template v-slot:item.preco="{ item }">
                    <span class="font-weight-bold">R$ {{ item.preco }}</span>
                </template>

                <template v-slot:item.grupoNome="{ item }">
                    <span class="caption grey--text text--darken-2">
                        {{ item.grupoNome }}
                    </span>
                </template>

                <template v-slot:item.acoes="{ item }">
                    <div class="d-flex align-center justify-end">
                        <NovaFuncaoDialog
                            :acaoEditar="true"
                            @recarregarLista="carregar"
                            :funcaoPassada="item"
                        />
                        <v-btn
                            color="red"
                            dark
                            small
                            icon
                            title="Excluir serviço"
                            aria-label="Excluir serviço"
                            @click="deletar(item)"
                        >
                            <v-icon small>fa fa-trash</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <v-card v-else class="empty-state pa-8 text-center" outlined>
            <v-icon color="indigo lighten-1" size="48">mdi-content-cut</v-icon>
            <h3 class="headline indigo--text text--darken-2 mt-4 mb-2">Nenhum serviço cadastrado</h3>
            <p class="body-2 grey--text text--darken-1 mb-0">
                Cadastre o primeiro serviço para disponibilizá-lo no agendamento.
            </p>
        </v-card>
            </v-tab-item>

            <v-tab-item>
                <v-card class="order-card" outlined>
                    <v-card-title class="d-flex flex-wrap align-center justify-space-between">
                        <div>
                            <div class="headline indigo--text text--darken-2">Ordem de exibição</div>
                            <div class="body-2 grey--text text--darken-1 mt-1">
                                Defina a posição e escolha o grupo de cada serviço na tela de agendamento.
                            </div>
                        </div>
                        <div class="d-flex align-center flex-wrap mt-2 mt-md-0">
                            <v-chip color="indigo lighten-5" text-color="indigo darken-2" class="mr-2">
                                {{ items.length }} serviços
                            </v-chip>
                            <v-btn text small color="primary" @click="dialogGrupos = true">
                                <v-icon left small>mdi-folder-edit-outline</v-icon>
                                Editar grupos
                            </v-btn>
                        </div>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-form ref="ordemForm">
                            <v-row
                                v-for="item in items"
                                :key="item.id || item.descricao"
                                align="center"
                                class="order-row"
                            >
                                <v-col cols="12" md="6">
                                    <div class="font-weight-bold indigo--text text--darken-3">
                                        {{ item.descricao }}
                                    </div>
                                    <div class="caption grey--text text--darken-1">
                                        {{ item.tempo }} · R$ {{ item.preco }}
                                    </div>
                                </v-col>

                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field
                                        v-model.number="item.ordem"
                                        type="number"
                                        min="1"
                                        label="Ordem"
                                        dense
                                        outlined
                                        hide-details="auto"
                                        :error-messages="ordemComErro(item)"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="8" md="4">
                                    <v-select
                                        v-model="item.grupoId"
                                        :items="grupos"
                                        item-text="nome"
                                        item-value="id"
                                        label="Grupo"
                                        dense
                                        outlined
                                        :disabled="!grupos.length"
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions class="pa-4">
                        <span class="caption grey--text text--darken-1">
                            Use números únicos para evitar empates na ordenação.
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn text :disabled="salvandoOrdem" @click="carregar">
                            Desfazer
                        </v-btn>
                        <v-btn
                            color="primary"
                            :loading="salvandoOrdem"
                            :disabled="salvandoOrdem || !ordemFormValida"
                            @click="salvarOrdem"
                        >
                            Salvar ordem
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>
        </v-tabs-items>

        <v-dialog v-model="dialogGrupos" max-width="560">
            <v-card>
                <v-card-title class="d-flex align-center justify-space-between">
                    <span class="headline indigo--text text--darken-2">Editar grupos</span>
                    <v-btn icon @click="dialogGrupos = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <v-form @submit.prevent="criarGrupo">
                        <v-text-field
                            v-model="novoGrupoNome"
                            label="Nome do novo grupo"
                            placeholder="Ex.: Combos"
                            outlined
                            dense
                            hide-details="auto"
                            class="mb-3"
                        ></v-text-field>
                        <v-btn type="submit" color="primary" block :loading="salvandoGrupos">
                            <v-icon left>mdi-plus</v-icon>
                            Criar grupo
                        </v-btn>
                    </v-form>

                    <v-divider class="my-5"></v-divider>

                    <v-list dense>
                        <v-list-item v-for="grupo in grupos" :key="grupo.id">
                            <v-list-item-content>
                                <v-list-item-title>{{ grupo.nome }}</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ quantidadeServicosGrupo(grupo) }}
                                    {{ quantidadeServicosGrupo(grupo) === 1 ? 'serviço' : 'serviços' }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn
                                    icon
                                    color="red"
                                    :disabled="grupo.reservado || grupoEmUso(grupo)"
                                    :title="grupo.reservado ? 'Grupo padrão' : (grupoEmUso(grupo) ? 'Grupo em uso' : 'Excluir grupo')"
                                    @click="removerGrupo(grupo)"
                                >
                                    <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>

                    <div class="caption grey--text text--darken-1 mt-3">
                        Grupos padrão ou associados a serviços não podem ser excluídos.
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import NovaFuncaoDialog from './Components/NovaFuncaoDialog'
import firebase from "firebase"

    export default {
        components: {
            NovaFuncaoDialog
        },

        data(){
            return {
                dbRef: firebase.firestore().collection('funcoes'),
                gruposRef: firebase.firestore().collection('configuracoes').doc('grupos-servicos'),
                items: [],
                grupos: [],
                gruposPadrao: [
                    { id: 'principais', nome: 'Principais', reservado: true },
                    { id: 'novos', nome: 'Novos serviços', reservado: true }
                ],
                busca: '',
                headers: [
                    { text: 'Serviço', value: 'descricao' },
                    { text: 'Seção', value: 'grupoNome', sortable: false },
                    { text: 'Preço', value: 'preco' },
                    { text: 'Duração', value: 'tempo', sortable: false },
                    { text: 'Ações', value: 'acoes', sortable: false, align: 'end' }
                ],
                abaSelecionada: 0,
                salvandoOrdem: false,
                salvandoGrupos: false,
                dialogGrupos: false,
                novoGrupoNome: '',
            }
        },
        async created() {
            try {
                await this.carregarGrupos()
            } catch (error) {
                this.grupos = this.gruposPadrao.map((grupo) => ({...grupo}))
                this.$toasted.global.defaultError({ msg: error.message })
            }
            await this.carregar()
        },
        methods: {
            async carregarGrupos(){
                const snap = await this.gruposRef.get()
                const armazenados = snap.exists && Array.isArray(snap.data().grupos)
                    ? snap.data().grupos
                    : []
                const grupos = this.gruposPadrao.map((padrao) => {
                    const salvo = armazenados.find((grupo) => grupo.id === padrao.id)
                    return {
                        ...padrao,
                        ...(salvo || {}),
                        reservado: true
                    }
                })

                armazenados
                    .filter((grupo) => grupo && grupo.id && grupo.nome)
                    .filter((grupo) => !grupos.some((existente) => existente.id === grupo.id))
                    .forEach((grupo) => grupos.push({
                        id: grupo.id,
                        nome: grupo.nome,
                        reservado: false
                    }))

                this.grupos = grupos
                const idsPadrao = this.gruposPadrao.map((grupo) => grupo.id)
                const faltamPadroes = idsPadrao.some((id) => !armazenados.some((grupo) => grupo.id === id))
                if(!snap.exists || faltamPadroes){
                    await this.gruposRef.set({grupos: this.grupos}, {merge: true})
                }
            },

            async carregar(){
                const snap = await this.dbRef.get()
                this.items = snap.docs
                    .map((doc, index) => {
                        const data = doc.data()
                        const ordem = Number(data.ordem)
                        const grupoId = data.grupoId || (data.grupo === 'principais' ? 'principais' : 'novos')
                        const grupo = this.grupos.find((item) => item.id === grupoId)
                        return {
                            ...data,
                            id: doc.id,
                            grupo: grupoId === 'principais' ? 'principais' : 'novos',
                            grupoId,
                            grupoNome: data.grupoNome || (grupo ? grupo.nome : 'Novos serviços'),
                            ordem: Number.isFinite(ordem) && ordem > 0 ? ordem : 1000 + index
                        }
                    })
                    .sort((a, b) => a.ordem - b.ordem)
            },

            async criarGrupo(){
                const nome = (this.novoGrupoNome || '').trim()
                if(!nome){
                    this.$toasted.global.defaultError({ msg: 'Informe o nome do grupo.' })
                    return
                }

                const existe = this.grupos.some((grupo) => grupo.nome.toLowerCase() === nome.toLowerCase())
                if(existe){
                    this.$toasted.global.defaultError({ msg: 'Já existe um grupo com esse nome.' })
                    return
                }

                this.salvandoGrupos = true
                try {
                    const grupo = {
                        id: `grupo-${Date.now()}`,
                        nome,
                        reservado: false
                    }
                    const gruposAtualizados = [...this.grupos, grupo]
                    await this.gruposRef.set({grupos: gruposAtualizados}, {merge: true})
                    this.grupos = gruposAtualizados
                    this.novoGrupoNome = ''
                    this.$toasted.global.defaultSuccess('Grupo criado com sucesso!')
                } catch (error) {
                    this.$toasted.global.defaultError({ msg: error.message })
                } finally {
                    this.salvandoGrupos = false
                }
            },

            quantidadeServicosGrupo(grupo){
                return this.items.filter((item) => item.grupoId === grupo.id).length
            },

            grupoEmUso(grupo){
                return this.quantidadeServicosGrupo(grupo) > 0
            },

            async removerGrupo(grupo){
                if(grupo.reservado || this.grupoEmUso(grupo)){
                    return
                }
                if(!confirm(`Excluir o grupo "${grupo.nome}"?`)){
                    return
                }

                this.salvandoGrupos = true
                try {
                    const gruposAtualizados = this.grupos.filter((item) => item.id !== grupo.id)
                    await this.gruposRef.set({grupos: gruposAtualizados}, {merge: true})
                    this.grupos = gruposAtualizados
                    this.$toasted.global.defaultSuccess('Grupo excluído com sucesso!')
                } catch (error) {
                    this.$toasted.global.defaultError({ msg: error.message })
                } finally {
                    this.salvandoGrupos = false
                }
            },

            ordemComErro(item){
                const ordem = Number(item.ordem)
                if(!Number.isInteger(ordem) || ordem < 1){
                    return 'Informe um número inteiro maior que zero.'
                }

                const repetida = this.items.some((outro) => {
                    return outro.id !== item.id && Number(outro.ordem) === ordem
                })

                return repetida ? 'Esta ordem já está sendo usada.' : ''
            },

            async salvarOrdem(){
                if(this.salvandoOrdem || !this.ordemFormValida){
                    return
                }

                this.salvandoOrdem = true
                try {
                    const batch = firebase.firestore().batch()
                    this.items.forEach((item) => {
                        const grupo = this.grupos.find((itemGrupo) => itemGrupo.id === item.grupoId)
                            || this.grupos.find((itemGrupo) => itemGrupo.id === 'novos')
                        batch.update(this.dbRef.doc(item.id), {
                            grupo: grupo && grupo.id === 'principais' ? 'principais' : 'novos',
                            grupoId: grupo ? grupo.id : 'novos',
                            grupoNome: grupo ? grupo.nome : 'Novos serviços',
                            ordem: Number(item.ordem)
                        })
                    })
                    await batch.commit()

                    this.$toasted.global.defaultSuccess('Ordem de exibição atualizada!')
                    await this.carregar()
                } catch (error) {
                    this.$toasted.global.defaultError({ msg: error.message })
                } finally {
                    this.salvandoOrdem = false
                }
            },

            deletar(item){
                if(confirm("Deseja apagar mesmo?")){
                    this.dbRef.doc(item.id).delete().then(() =>{
                    console.log("Apagado!");
                    this.$toasted.global.defaultSuccess("Apagado com sucesso!");
                    this.carregar()
                });
                }
            }
        },
        computed: {
            ordemFormValida(){
                return this.items.length > 0 && this.items.every((item) => {
                    return this.ordemComErro(item) === ''
                })
            }
        }
    }
</script>

<style scoped>
.funcoes-page {
    max-width: 1280px;
}

.page-header {
    background: linear-gradient(135deg, #3949ab 0%, #5c6bc0 100%) !important;
    border-radius: 24px 24px 24px 6px;
}

.services-list-card {
    border-radius: 18px;
    overflow: hidden;
}

.services-table {
    border-radius: 18px;
}

.service-search {
    max-width: 280px;
    min-width: 220px;
}

.empty-state {
    border-radius: 18px;
}

.order-card {
    border-radius: 18px;
}

.order-row + .order-row {
    border-top: 1px solid rgba(63, 81, 181, 0.1);
    margin-top: 8px;
    padding-top: 8px;
}

@media (max-width: 600px) {
    .page-header {
        border-radius: 18px 18px 18px 4px;
    }

    .page-header .display-2 {
        font-size: 2.2rem !important;
    }

    .service-search {
        margin-bottom: 12px;
        max-width: none;
        min-width: 100%;
    }
}
</style>
